// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"d4fba6e9","42":"2aa18c0b","133":"400c1498","167":"db49ea99","173":"e4cc66dc","253":"a3afc6fd","470":"54d5f494","534":"a8a0b9ee","598":"c6df6d95","654":"e8c815ae","681":"d4cd2a76","697":"ab5dc287","879":"a11330ea","900":"74236601","979":"0935903d"}[chunkId] + ".chunk.js";
};